import React from 'react';
import './styles.scss';


type SessionListSessionTypePill = {
  type: string;
  children: React.ReactNode;
}

export const SessionListSessionTypePill = ({ type, children }: SessionListSessionTypePill) => {
  const typeClassname = (t: string)=> {
    switch (t) {
      case 'VR solo':
        return 'vr-solo';
      case 'VR w/specialist':
        return 'vr-w-specialist';
      default:
        return '';
    }
  };

  return (
    <p className={`session-list-session-type-pill type-${typeClassname(type)}`}>
      {children}
    </p>
  )
};
